<template>
    <div>
        <div class="container " style="padding-top:70px;">
            <div class="row">
                <div class="col-sm-2" v-if="webW">
                    <div id="JfLeftMenuOut">
                        <div :class="(fixedleftmenu?'fixedJfLeftMenu':'')"
                             :style="fixedleftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">

                            <MySet></MySet>


                        </div>
                        <div v-if="fixedleftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                    </div>
                </div>
                <div :class="(webW?'col-sm-10':'col-sm-12')">
                    <div>

                        <el-card class="box-card">
                            <div slot="header" class="tishi">
                                <span>修改密码</span>

                            </div>
                            <div>

                                <el-form
                                         label-width="0px"
                                        :model="dataForm"
                                        :rules="dataFormRule"
                                        ref="dataForm"
                                >
                                    <el-form-item prop="oldp">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input type="password" placeholder="请输入原密码" v-model="dataForm.oldp"   show-password>
                                                    <template #prepend>
                                                        原密码
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6">
                                                <span class="inptip">输入原密码才可修改新密码</span>
                                            </div>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="newp">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input type="password" placeholder="请输入新密码" v-model="dataForm.newp"   show-password>
                                                    <template #prepend>
                                                         新密码
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6">
                                                <span class="inptip">格式：6-20位数字或者字母下划线组成</span>
                                            </div>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="newp2">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input type="password" placeholder="请输入确认密码" v-model="dataForm.newp2"   show-password>
                                                    <template #prepend>
                                                         确认密码
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6">
                                                <span class="inptip">格式：6-20位数字或者字母下划线组成</span>
                                            </div>
                                        </div>
                                    </el-form-item>




                                </el-form>

                                <div >
                                    <el-button type="warning" round @click="saveEdit">
                                        确定修改
                                    </el-button>
                                </div>
                            </div>


                        </el-card>
                        <br>

                        <el-card class="box-card">
                            <div slot="header" class="tishi">
                                <span>邮箱验证</span>

                            </div>
                            <div>

                                <p v-if="emailEdit==1">邮箱 {{dataFormE.email}} 已通过验证
                                    <el-button @click="emailEdit=0" icon="el-icon-edit">修改邮箱</el-button>
                                </p>
                                <el-form v-if="emailEdit==0"
                                          label-width="0px"
                                         :model="dataFormE"
                                         :rules="dataFormRuleE"
                                         ref="dataFormE"
                                >


                                    <el-form-item prop="email">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input   placeholder="请输入原密码" v-model="dataFormE.email"    >
                                                    <template #prepend>
                                                        邮箱
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6">
                                                <span class="inptip">{{emailVaild==1?'已验证':'未验证，验证过的邮箱可用于找回密码哦'}} <el-button
                                                        v-if="emailVaild==1" @click="emailEdit=1" type="text">[暂不修改]</el-button></span>
                                            </div>
                                        </div>
                                    </el-form-item>


                                    <el-form-item prop="code">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <el-input placeholder="请输入验证码" type="number" v-model="dataFormE.code">
                                                    <template slot="prepend">验证码</template>
                                                    <template slot="append">
                                                        <el-button type="danger"   @click="sendCode" :disabled="ts==60?false:true">
                                                            {{tsmsg}}
                                                        </el-button>
                                                    </template>
                                                </el-input>
                                            </div>
                                            <div class="col-sm-6"></div>
                                        </div>

                                    </el-form-item>

                                    <div  >
                                        <el-button type="warning" round @click="saveEditE">
                                            绑定邮箱
                                        </el-button>
                                    </div>

                                </el-form>


                            </div>
                            <br>
                            <br>
                            <br>


                        </el-card>


                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

    import {getMyUserinfo, updateMyUpass, checkOne, sendEmailCode, bandEmail} from '../../../api';
    import {dealResult, getWindowWidth} from "../../../api/common";
    import {validateEmail, validateUpass} from "../../../api/validator";
    import MySet from "./MySet";
    export default {
        name: 'UpUpass',
        components: {MySet},

        data() {

            const confirmPassword = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("请输入密码");
                } else if (str !== this.dataForm.newp) {
                    callback('两次输入密码不一致!');
                } else {
                    callback();
                }
            };
            const checkExistEmail = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    checkOne({
                        name: 'email', value: str, uid: this.lander.uid,
                        token: this.lander.token
                    }).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            return {
                fixedleftmenu:false,
                LeftMenuWidth:0,
                webW:true,

                ts: 60,
                tsmsg: '点击发送',

                islogin: '',
                lander: {},

                emailVaild: 0,
                emailEdit: 0,

                dataForm: {
                    oldp: '',
                    newp: '',
                    newp2: '',

                },
                dataFormRule: {

                    oldp: [{required: true, message: '不能为空', trigger: 'blur'}],

                    newp: [
                        {required: true, message: "密码不能为空", trigger: "blur"},
                        {validator: validateUpass, trigger: "blur"},
                    ],
                    newp2: [
                        {required: true, message: "密码不能为空", trigger: "blur"},
                        {validator: confirmPassword, message: "密码不一致", trigger: ["change", "blur"]}
                    ],

                },
                dataFormE: {
                    email: '',
                    code: '',

                },
                dataFormRuleE: {

                    email: [
                        {required: true, message: "邮箱不能为空", trigger: "blur"},
                        {validator: validateEmail, trigger: "blur"},
                        {validator: checkExistEmail, trigger: "blur"},
                    ],


                },
            };
        },
        methods: {

            saveEdit() {

                this.$refs.dataForm.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {
                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;
                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中，请稍等...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });

                        updateMyUpass(this.dataForm).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success("修改成功");
                                this.dataForm = {};
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).catch(() => {
                            this.loading.close();
                            this.$message.info('请求失败，请检查网络');
                        });
                    }
                })
            },
            saveEditE() {


                this.$refs.dataFormE.validate(valid => {
                    if (this.dataFormE.code.trim().length == 0) {
                        this.$message.info("请输入验证码");
                        return;
                    }
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {
                        this.dataFormE.uid = this.lander.uid;
                        this.dataFormE.token = this.lander.token;
                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中，请稍等...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });

                        bandEmail(this.dataFormE).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg);
                                this.getinfo();

                                localStorage.email = this.dataFormE.email;

                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).catch(() => {
                            this.loading.close();
                            this.$message.info('请求失败，请检查网络');
                        });
                    }
                })
            },
            sendCode() {


                this.$refs.dataFormE.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请写入正确的邮箱");
                        return false;
                    } else {
                        sendEmailCode({
                            email: this.dataFormE.email,
                            uid: this.lander.uid,
                            token: this.lander.token
                        }).then((res) => {

                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success(res.data.msg)

                                let seti = setInterval(() => {
                                    this.ts = this.ts - 1;
                                    this.tsmsg = "还剩" + this.ts + "秒";
                                    if (this.ts <= 0) {
                                        clearInterval(seti);
                                        this.ts = 60;
                                        this.tsmsg = "点击发送";
                                    }
                                }, 1000)
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })


                    }
                })
            },
            getinfo() {
                getMyUserinfo({uid: this.lander.uid, token: this.lander.token}).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.dataFormE.email = res.data.obj.user.email;
                        this.emailVaild = res.data.obj.user.emailVaild;
                        this.emailEdit = (this.emailVaild == '1') ? 1 : 0;

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },

            fixedmenu(){
                let JfLeftMenu=document.getElementById('JfLeftMenu');


                let that=this;

                window.onscroll = function () {
                    let t = document.documentElement.scrollTop || document.body.scrollTop;

                    that.LeftMenuWidth=JfLeftMenu.offsetWidth;
                    let LeftTop=JfLeftMenu.offsetTop;

                    if(t>LeftTop){
                        that.fixedleftmenu=true;
                    }else{
                        that.fixedleftmenu=false;
                    }



                }
            },
        }, mounted() {
            this.webW=getWindowWidth()>=1000?true:false;
            if( this.webW) this.fixedmenu();

            if (document.documentElement != undefined) document.documentElement.scrollTop = 0;
            if (document.body != undefined) document.body.scrollTop = 0;


            this.lander = JSON.parse(this.$store.state.logininfo);

            this.getinfo();


        }, activated() {



            //固定左右菜单
            this.fixedmenu();


        },
        deactivated() {

        }
    };
</script>
<style scoped>


    .inptip {
        margin-left: 10px;
        color: #aaa;
        font-size: 12px;
    }
</style>
